import React from "react";
import PropTypes from "prop-types";
import { MathJax } from "better-react-mathjax";
import style from "./style.module.scss";

/**
 * HintArea for the Question footer component;
 */
export function HintArea(props) {
  return (
    <div
      className={style.hintArea}
      style={{ display: !props.showHint ? "none" : null }}
    >
      <h4>Hint</h4>
      <p>
        <MathJax inline dynamic>
          {props.hint}
        </MathJax>
      </p>
    </div>
  );
}

HintArea.propTypes = {
  /**
   * The hint text
   */
  hint: PropTypes.number,
  /**
   * Boolean value controlling whether the hint is shown or not
   */
  showHint: PropTypes.bool.isRequired,
};
